import { useCallback, useRef } from 'react';
import { log } from 'log';
import { useDispatch } from 'react-redux';
import { useShowNotification } from 'js/hooks/useShowNotification';
import { toggleFavoriteGame } from 'js/hooks/games/store/actions';

import * as server from './server';
import { useFavoritesTracking } from './useFavoritesTracking';

export const useToggleFavorite = ({ code, isFavorite, gameFeed, translate, setAfterToggleInfo }) => {
    const dispatch = useDispatch();
    const showNotification = useShowNotification();
    const trackAPIEvent = useFavoritesTracking({ gameCode: code, isFavorite, gameFeed });
    const inProgress = useRef(false);

    return useCallback(() => {
        // prevent double-click
        if (inProgress.current) {
            return;
        }

        inProgress.current = true;

        trackAPIEvent();

        (async () => {
            try {
                const newValue = !isFavorite;
                const messageTKey = newValue
                    ? 'playtech.mobile.system.toast.favoritesAdd'
                    : 'playtech.mobile.system.toast.favoritesRemove';

                await server.changeFavorite({ code, isFavorite: newValue });

                showNotification(messageTKey, { variant: 'info' });
                setAfterToggleInfo(newValue ? translate('added.successfully') : translate('removed.successfully'));
                dispatch(toggleFavoriteGame({ gameCodes: [code], isFavorite: newValue }));
            } catch (error) {
                log('error', error);
            } finally {
                inProgress.current = false;
            }
        })();
    }, [
        inProgress, code, translate, dispatch,
        isFavorite, showNotification, trackAPIEvent, setAfterToggleInfo
    ]);
};
